module.exports = __webpack_public_path__ + "img/programmeur.26bb1eb2.svg";